import { render, staticRenderFns } from "./addNews.vue?vue&type=template&id=0ccc0897"
import script from "./addNews.vue?vue&type=script&lang=js"
export * from "./addNews.vue?vue&type=script&lang=js"
import style0 from "./addNews.vue?vue&type=style&index=0&id=0ccc0897&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports